import { useEffect } from 'react';
import { useInvitePeopleModal } from '@atlassian/invite-people/InvitePeopleModalContext';
import type { InvitePromptOnLinKInsertContext } from '../../common/types';

const TriggerInvitePeopleModal = (context: InvitePromptOnLinKInsertContext) => {
	const { experimental_openModal: openInvitePeopleModal } = useInvitePeopleModal({
		resourceAri: '',
	});
	useEffect(() => {
		openInvitePeopleModal({
			...context,
			disableViralSettings: true,
			enableThirdParty: true,
		});
		// useInvitePeopleModal always return a new function, and it caused an infinite loop
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [context]);
	return null;
};

export default TriggerInvitePeopleModal;
